import { useTranslation } from '@/feature/lang';
import type { Translation } from '@/feature/lang/types';

const DEFAULT_TITLE = 'SAM - Sandvik';

interface DocumentTitleProps {
  title?: Translation;
}

export const DocumentTitle = ({ title }: DocumentTitleProps) => {
  const { translate } = useTranslation();
  const translatedTitle = translate(title);

  return (
    <title>
      {translatedTitle ? `${translatedTitle} | SAM` : DEFAULT_TITLE}
    </title>
  );
};
